import * as j01 from '../actions/j01.actions';

export interface State {
  j01: any;
}

export const initialState = {
    'policy_information': [
        {
        }
    ]
};


export function reducer(state = initialState, action: j01.Actions) {
  switch (action.type) {
    case j01.GO_TO_PAGE_J01: {
      const payload = action.payload;
      const result = [];
      payload[0].policy.forEach(e => {
              e.policyBenefitInfoView.forEach(d => {
                  result.push({
                        'J01_04': d.coverageType,
                        'J01_05': d.policyNo,
                        'J01_06': d.coverageName + d.coverageSymbol,
                        'J01_07': d.policyCurrency,
                        'J01_08': d.coverageExpiryDate,
                        'J01_09': d.premiumExpiryDate,
                        'J01_10': d.sumInsuredOrAmount
                  });
              });
      });
      return Object.assign({}, state, {'policy_information': result});
    }

    default:
      return state;
  }
}
